import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { SavedQuoteConfigService, CartsService, CreationDateFilterService, Cart } from 'gung-standard';
import { CarLinerSavedQuoteTableComponent } from '../components/car-liner-saved-quote-table/car-liner-saved-quote-table.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerSavedQuoteConfigService extends SavedQuoteConfigService {
  constructor(protected cartsService: CartsService, protected creationDateFilterService: CreationDateFilterService) {
    super(cartsService, creationDateFilterService);
  }

  getLayouts(): ListLayout<Cart>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerSavedQuoteTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'SavedQuoteGrid'
      }
    ];
  }
}
